/** The SuperFunUBG logo: the blue fuzzy monster (source art: scripts/brand/logo-source.png). */
export function LogoMark({ size = 36 }: { size?: number }) {
  return <img src={size > 64 ? '/logo-192.png?v=3' : '/logo-64.png?v=3'} width={size} height={size} alt="" className="logo-mark" />;
}

export function Wordmark() {
  return (
    <span className="wordmark">
      <LogoMark />
      <span className="wordmark__text">
        Two<span className="wordmark__accent-blue">Player</span>
        <span className="wordmark__ubg">UBG</span>
      </span>
    </span>
  );
}
